import axios from '@/plugins/axios';

export function isMySupplier(buyUserId, supplierUserId) {
  return axios.get('/userSupplier/isMySupplier', {
    params: {
      buyUserId: buyUserId,
      supplierUserId: supplierUserId
    }
  });
}
// 保存为我的供应商
export function addSupplier(params) {
  return axios.post('/userSupplier/saveMySupplier', params);
}
// 修改我的供应商
export function editSupplier(params) {
  return axios.post('/userSupplier/editMySupplier', params);
}
// 关注或取消关注
export function followCompany(companyId) {
  return axios.get('/userSupplier/followCompany', {
    params: {
      companyId: companyId
    }
  });
}
// 查询企业往来
export function listHistory(params) {
  return axios.get('/userSupplier/newListHistory', {
    params: params
  });
}
// 全部供应商列表
export function listSupplier(params) {
  return axios.get('/userSupplier/listSupplier', {
    params: params
  });
}
// 我的供应商列表
export function listOwnSupplier(params) {
  return axios.get('/userSupplier/listUserSupplier', {
    params: params
  });
}
// 关注列表
export function listFollow(params) {
  return axios.get('/userSupplier/listFollow', {
    params: params
  });
}
// 客户列表
export function listBuyer(params) {
  return axios.get('/userBuyer/listUserBuyer', {
    params: params
  });
}
